import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: _ctx.wizardStep,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wizardStep) = $event)),
    touchless: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window_item, {
        value: 0,
        class: "pa-0"
      }, {
        default: _withCtx(() => [
          (_ctx.showSwitchs)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "pt-1 mx-2 justify-center",
                style: {"min-width":"550px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        modelValue: _ctx.noHeaders,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.noHeaders) = $event)),
                        label: "Sans en-têtes",
                        "hide-details": "",
                        color: "primary",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oss_text_field_filled, {
                        modelValue: _ctx.startLine,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startLine) = $event)),
                        rules: [(v) => v < _ctx.maxStartLine],
                        disabled: !_ctx.noHeaders,
                        "hide-details": "",
                        density: "compact",
                        label: "Ligne de début"
                      }, null, 8, ["modelValue", "rules", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "px-2 justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    density: "compact",
                    headers: _ctx.headersCorrespondance,
                    items: _ctx.itemsCorrespondance,
                    "hide-default-footer": "",
                    "items-per-page": -1,
                    class: "table",
                    "fixed-header": ""
                  }, {
                    headers: _withCtx(() => [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headersCorrespondance, (header, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: index,
                            style: _normalizeStyle(_ctx.getHeaderStyle())
                          }, _toDisplayString(header.text), 5))
                        }), 128))
                      ])
                    ]),
                    item: _withCtx(({ item, index }) => [
                      _createElementVNode("tr", {
                        style: _normalizeStyle(_ctx.getRowStyle(index))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (wording, windex) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: index+'-'+windex
                          }, _toDisplayString(wording), 1))
                        }), 128))
                      ], 4)
                    ]),
                    _: 1
                  }, 8, ["headers", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, { value: 1 }, {
        default: _withCtx(() => [
          (!_ctx.allDatesValid && _ctx.requireDateVerification)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_alert, {
                        dense: "",
                        type: "warning"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "align-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { class: "grow" }, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createElementVNode("div", null, "Certaines dates sont dans un exercice clôturé", -1),
                                  _createElementVNode("div", { style: {"font-size":"12px"} }, " Si vous continuez, ces transactions bancaires seront supprimées. ", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.foundErrors.length)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_alert, {
                        density: "compact",
                        type: "warning",
                        text: _ctx.errorDescription
                      }, null, 8, ["text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "pt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.requireDateVerification && _ctx.updateAccountingDates ? 10 : 12,
                class: "d-flex justify-start flex-wrap"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_chip, {
                    variant: "text",
                    density: "compact",
                    class: "mb-1"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode(" Données requises : ")
                    ])),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatColumns.filter(
                            (c) => c.mandatory && !c.pair && !c.optional,
                        ), (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      color: _ctx.positions[item.value] ? 'success' : 'error',
                      density: "compact",
                      variant: "outlined",
                      key: index,
                      style: {"margin-left":"4px"},
                      class: "mb-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatColumns.filter((c) => c.pair), (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      color: 
                            _ctx.positions[item.value] ? 'success' : item.optional ? 'orange' : 'error'
                        ,
                      style: _normalizeStyle([_ctx.columnOptions('pairs', item) ? '' : 'display:none', {"margin-left":"4px"}]),
                      density: "compact",
                      variant: "outlined",
                      key: 'A' + index,
                      class: "mb-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["color", "style"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatColumns.filter(
                            (c) => c.optional && c.mandatory,
                        ), (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      color: 
                            _ctx.positions[item.value]
                                ? 'success'
                                : _ctx.columnOptions('selection', item)
                                  ? 'orange'
                                  : 'error'
                        ,
                      density: "compact",
                      variant: "outlined",
                      key: 'B' + index,
                      style: {"margin-left":"4px"},
                      class: "mb-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatColumns.filter(
                            (c) => c.optional && !c.pair && !c.mandatory,
                        ), (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      color: _ctx.positions[item.value] ? 'success' : 'orange',
                      density: "compact",
                      variant: "outlined",
                      key: 'C' + index,
                      style: {"margin-left":"4px"},
                      class: "mb-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["cols"]),
              (_ctx.requireDateVerification && _ctx.updateAccountingDates)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "2",
                    class: "pr-1 d-flex justify-end align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "btn",
                        rounded: "",
                        size: "x-small",
                        color: "secondary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateDates())),
                        disabled: _ctx.correctDatesAndHeaders()
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode(" Mise à jour des dates ")
                        ])),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "px-2 justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_data_table, {
                    headers: _ctx.headersCorrespondance,
                    items: _ctx.itemsCorrespondance,
                    rowStyles: _ctx.invalidDates,
                    "fixed-header": true,
                    "fixed-footer": true,
                    striped: true,
                    "x-dense": true
                  }, {
                    "header.append": _withCtx(() => [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headersCorrespondance, (header, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            class: "header",
                            style: {"top":"26px","font-weight":"normal"},
                            key: index
                          }, [
                            (
                                            _ctx.headersCorrespondance[index].value !== 'accountingDate'
                                        )
                              ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                  key: 0,
                                  modelValue: _ctx.itemsSelection[index].type,
                                  "onUpdate:modelValue": [($event: any) => ((_ctx.itemsSelection[index].type) = $event), ($event: any) => (_ctx.onItemsChanged(_ctx.itemsSelection[index]))],
                                  items: _ctx.formatColumns,
                                  "item-title": "text",
                                  "item-value": "value",
                                  "hide-details": "",
                                  "min-width": "100px",
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "rowStyles"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}